
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"그룹 1398","transform":"translate(-635.982 -442.425)"}},[_c('rect',{attrs:{"data-name":"사각형 1670","width":"14","height":"20","rx":"1","transform":"translate(635.982 442.425)","fill":"#f36628"}}),_c('rect',{attrs:{"data-name":"사각형 1671","width":"3","height":"3","rx":"1","transform":"translate(638.982 445.425)","fill":"#fff"}}),_c('rect',{attrs:{"data-name":"사각형 1672","width":"3","height":"3","rx":"1","transform":"translate(643.982 445.425)","fill":"#fff"}}),_c('g',{attrs:{"data-name":"그룹 1165"}},[_c('path',{attrs:{"data-name":"패스 564","d":"M642.982 452.425a3 3 0 000 6 2.969 2.969 0 001.286-.3 3 3 0 001.414-1.414 2.964 2.964 0 00.3-1.285 3 3 0 00-3-3.001z","fill":"#fff"}}),_c('path',{attrs:{"data-name":"패스 565","d":"M649.689 460.718l-2.539-2.539a5.011 5.011 0 10-1.414 1.414l2.539 2.539a1 1 0 001.414-1.414zm-6.707-2.293a3 3 0 113-3 2.964 2.964 0 01-.3 1.285 3 3 0 01-1.414 1.414 2.969 2.969 0 01-1.286.301z"}})])])])
          )
        }
      }
    